export const TERMS_OF_SERVICE = "https://www.prophia.com/abstract-terms";
export const PRIVACY_POLICY = "https://www.prophia.com/privacy-policy";
export const HOME_PAGE = "https://www.prophia.com";
export const ZOOM_LINK =
  "https://scheduler.zoom.us/d/8e3win7f/prophia-abstract-feedback";
export const ABSTRACT_LINK = "https://prophia.com/instant-lease-abstract";
export const SUPPORT_CENTER =
  "https://support.prophia.com/kb/guide/en/prophia-abstract-ibohkGrAM9/Steps/4208859";
